export class TwoFactorAtuhModel {
  message?: string;
  requires_2fa?: boolean;

  two_factor_token?: string;

  retry_after?: number;
  resend_available_at?: string;
  code_expires_at?: string;

  remaining_attempts?: number;
  requires_login?: boolean;

  constructor(data?: Partial<TwoFactorAtuhModel>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export interface TwoFactorVerifyRequest {
  username: string;
  code: string;
  two_factor_token: string;
}

export interface TwoFactorResendRequest {
  username: string;
  two_factor_token: string;
}